waitFor_jQuery(function () {


    $(document).on('click', '.qty-wrapper>.plus:not(.disabled), .qty-wrapper>.minus:not(.disabled)', function () {
        var ths = $(this), 
            $input = ths.parent().find('input'), 
            multiple = 1,
            isCart = ths.is('.cart-qty'),
            currentVal = parseInt($input.val());
        if( isNaN(currentVal) && !isCart ) { currentVal = multiple; }
        // if( isNaN(currentVal) && isCart ) { currentVal = 0; }
        if( $(this).hasClass('plus') ) {
            currentVal += multiple;
        } else {
            if ( isCart ) {
                currentVal = currentVal - multiple;
            } else {
                currentVal = currentVal > multiple ? currentVal - multiple : multiple;
            }
        }
        $input.val(currentVal).trigger('change');
    });

    const defaults = {
        cartModal: '.js-ajax-cart-modal', // classname
        cartModalContent: '.js-ajax-cart-modal-content', // classname
        cartModalClose: '.js-ajax-cart-modal-close', // classname
        cartDrawer: '.js-ajax-cart-drawer', // classname
        cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
        cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
        cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
        cartOverlay: '.js-ajax-cart-overlay', // classname
        cartCounter: '[data-cart-count]', // classname
        addToCart: '.js-ajax-add-to-cart', // classname
        removeFromCart: '.js-ajax-remove-from-cart', //classname
        removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
        checkoutButton: '.js-ajax-checkout-button',
    };
    // console.log('hello')


    const cartModal = document.querySelector(defaults.cartModal);
    const cartModalContent = document.querySelector(defaults.cartModalContent);
    const cartModalClose = document.querySelector(defaults.cartModalClose);
    const cartDrawer = document.querySelector(defaults.cartDrawer);
    const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
    const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
    const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
    const cartOverlay = document.querySelector(defaults.cartOverlay);
    var cartCounter = document.querySelectorAll(defaults.cartCounter);
    const addToCart = document.querySelectorAll(defaults.addToCart);
    let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
    const checkoutButton = document.querySelector(defaults.checkoutButton);
    const htmlSelector = document.documentElement;

    // console.log(addToCart)

    for (let i = 0; i < addToCart.length; i++) {

        addToCart[i].addEventListener('click', function(event) {

            if ( addToCart[i].classList.contains('product-item--submit') || addToCart[i].classList.contains('cart-addon-submit') ) {
                event.preventDefault();
            }
            // console.log($(this).parents().find('form'));
            const formID =  $(this).closest('.product-form').attr('id');
            //const formID = this.parentNode.getAttribute('id');
            // console.log(formID);

            addProductToCart(formID);

        });

    }


    function addProductToCart(formID) {
        // console.log(formID)
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: $('#' + formID)
                .serialize(),
            success: addToCartOk,
            error: addToCartFail,
        });
        addAddOnToCart(formID);
    }
    function addAddOnToCart(formID) {
        var itemProd=[];
        var addons = $('input[name=addons]:checked');

        addons.each(function(){
            itemProd.push({
                "id": $(this).val(),
                "quantity": 1,
            })

            // Do stuff here with this
        });
        // console.log(itemProd.length);
        if(itemProd.length > 0){
            setTimeout(
                function()
                {
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: {
                            items: itemProd
                        },
                        success: addToCartOk,
                        error: addToCartFail,
                    });
                    // console.log(ok);
                }, 2000);

        }

    }


    function fetchCart() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
                onCartUpdate(cart);

                if (cart.item_count === 0) {
                    cartDrawerContent.innerHTML = $('.emptyCart').html();
                    $('.ajax-cart.banner').html("");
                    $('.ajax-cart-drawer__buttons').hide();
                    $(".ajax_suggestions").hide();
                    checkoutButton.classList.add('is-hidden');
                } else {

                    renderCart(cart);
                    checkoutButton.classList.remove('is-hidden');
                }

            },
        });
    }

    function changeItem(line,quantity, callback) {

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: 'quantity=' + quantity + '&line=' + line,
            dataType: 'json',
            success: function(cart) {
                if ((typeof callback) === 'function') {
                    callback(cart);
                } else {
                    onCartUpdate(cart);
                    fetchCart();
                    removeProductFromCart();
                }
            },
        });
    }

    function onCartUpdate(cart) {
        // console.log('items in the cart?', cart.item_count);
    }

    function addToCartOk(product) {
        cartModalContent.innerHTML = product.title + ' was added to the cart!';

        // openAddModal();
        // openCartOverlay();
        for (var i = 0; i < cartCounter.length; i++) {
            cartCounter[i].innerHTML = Number(cartCounter[i].innerHTML) + 1;
        }


        fetchCart();
        openCartDrawer();
        openCartOverlay();
    }

    function removeProductFromCart() {
        for (var i = 0; i < cartCounter.length; i++) {
            cartCounter[i].innerHTML = Number(cartCounter[i].innerHTML) - 1;
        }

    }

    function addToCartFail() {
        $('.js-ajax-add-to-cart .text').html("Sold Out");
        cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
        // openAddModal();
        // openCartOverlay();
    }

    function renderCart(cart) {

        $('.ajax-cart-drawer__buttons').show();
        // $(".ajax_suggestions").show();

        clearCartDrawer();
        // $('.recommendedProducts').show();
        var strapCounter = 0;
        // console.log(cart.items);

        $(".cart-addon-product,.cart-addon").removeClass('hide')
        cart.items.forEach(function(item, index) {
            if(item.properties){
                if(item.properties['_Strap'] ){

                    strapCounter =strapCounter + item.quantity ;
                }
            }
            var img = item.image;
            var img = img.replace(/(\.[^\.]+)$/, '_210x$&');
            // console.log(strapCounter);
            // console.log(item);
            // console.log(img);
            //console.log(item.line_price);
            //console.log(item.quantity);
            if($('#ProductSection-'+item.product_id).length > 0){
                $('#ProductSection-'+item.product_id).toggle();
            }



            $('[data-addon-id="'+item.product_id+'"]').addClass('hide');

            if ($(".cart-addon-product.hide").length == $(".cart-addon-product").length) {
                $('.cart-addon').addClass('hide')
            }

            const productPrice = item.original_price > item.discounted_price  ?"<s>$"+item.original_price*item.quantity/100+"</s>$"+(item.discounted_price*item.quantity)/100:"$"+item.line_price/100;

            var vrs = '';
            var ttl = item.product_title;

            if ( item.variant_title != null ) {
                var vrs = '<div class="ajax-cart-item__variant-title">'+item.variant_title+'</div>'
            }


            var itemHtml = 
                '           <div class="left-content">' +
                '               <div class="ajax-cart-item__image"><img src="'+(item.image).replace(/(\.[^\.]+)$/, '_200x$&')+'" alt=""></div>' +
                '           </div>' +
                '           <div class="right-content">' +
                '               <div class="ajax-cart-item__title">'+ttl+'</div>' + vrs +
                // '                   <div class="ajax-cart-item__variant">'+item.title+'</div>' +

                '               <div class="ajax-cart-item__quantity"><div class="qty-wrapper"><span id="qty-' + Number(index + 1) + '" for="qty-' + Number(index + 1) + '" class="visually-hidden">Quantity</span><span class="minus cart-qty"></span><input class="cart-item_no" id="qty-' + Number(index + 1) + '"  data-quantity-input name="quantity"  aria-labelledby="qty-' + Number(index + 1) + '" type="number" value="'+item.quantity+'" name="cart-item_no"  pattern="[0-9]*" min="0"><span class="plus cart-qty"></span></div></div>' +
                '               <div class="ajax-cart-item__price"><span class="ajax-cart-item__price-item">'+productPrice+'</span></div>' +
                '           </div>';

            const concatProductInfo = '<div class="ajax-cart-item__single" data-line="' + Number(index + 1) + '">' + itemHtml + '</div>';


            cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + concatProductInfo;

        });


        // document.querySelectorAll('.js-ajax-remove-from-cart')
        //     .forEach((element) => {
        //         element.addEventListener('click', function() {
        //             const lineID = this.parentNode.getAttribute('data-line');
        //             console.log('aa');
        //         });
        //     });

        //turn below script for dynamic cart drawer meesaging
        /*
        if(cart.total_discount > 0){
            var disc = Math.ceil(((cart.original_total_price - cart.total_price)/cart.original_total_price)*100);
            $('.ajax-cart.banner').html("Congrats! You saved "+disc+"%");


        }else{
            if(strapCounter > 2){
                $('.ajax-cart.banner').html("Congrats! You qualified for discount");
            }

           else if(strapCounter > 1){
                $('.ajax-cart.banner').html("Add 1 more strap to save 15%");
            }else{
                $('.ajax-cart.banner').html("Add 2 more straps to save 15%");

            }
        }

         */
        $('.ajax-cart.banner').html("$2 Shipping Worldwide");
        const cartTotal = cart.total_discount > 0 ?"<s>"+theme.Currency.formatMoney( cart.original_total_price)+"</s>"+theme.Currency.formatMoney( cart.total_price,theme.moneyFormatWithCurrency):theme.Currency.formatMoney( cart.total_price,theme.moneyFormatWithCurrency);
        $('.cart-subtotal__price').html(cartTotal);

        removeFromCart = document.querySelectorAll(defaults.removeFromCart);

        for (let i = 0; i < removeFromCart.length; i++) {
            removeFromCart[i].addEventListener('click', function() {
                const line = $(this).parents().find('.ajax-cart-item__single').attr('data-line');
                //const line = this.parentNode.getAttribute('data-line');

                changeItem(line,0);
            });
        }

        $('.cart-item_no').change(function () {
            const line = $(this).closest('.ajax-cart-item__single').attr('data-line');
            //const line = this.parentNode.getAttribute('data-line');

            changeItem(line,$(this).val());
        })


    }

    function openCartDrawer() {
        cartDrawer.classList.add('is-open');
    }

    function closeCartDrawer() {
        cartDrawer.classList.remove('is-open');
    }

    function clearCartDrawer() {
        cartDrawerContent.innerHTML = '';
    }

    function openAddModal() {
        cartModal.classList.add('is-open');
    }

    function closeAddModal() {
        cartModal.classList.remove('is-open');
    }

    function openCartOverlay() {
        cartOverlay.classList.add('is-open');
        htmlSelector.classList.add('is-locked');
    }

    function closeCartOverlay() {
        cartOverlay.classList.remove('is-open');
        htmlSelector.classList.remove('is-locked');
    }

    cartModalClose.addEventListener('click', function() {
        closeAddModal();
        closeCartOverlay();
    });

    cartDrawerClose.addEventListener('click', function() {
        closeCartDrawer();
        closeCartOverlay();
    });
    // cart is empty stanje
    cartOverlay.addEventListener('click', function() {
        closeAddModal();
        closeCartDrawer();
        closeCartOverlay();
    });

    cartDrawerTrigger.addEventListener('click', function(event) {

        event.preventDefault();
        //fetchCart();
        openCartDrawer();
        openCartOverlay();
    });

    waitFor_jQuery(function () {
        fetchCart();
    });

    // setTimeout(function (argument) {
    //     openCartDrawer();
    //     openCartOverlay();
    // },1000)

    // waitFor_jQuery(function () {
    //     $('.showInst').click(function () {
    //         $('.specialInst').show();
    //         $('.showInst').hide();
    //     })
    // })

})